import BootstrapTable from 'react-bootstrap-table-next';
import { React, useState } from 'react'
import { Link } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import Sidebar from './Sidebar';
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { FiUsers } from "react-icons/fi";


import paginationFactory from 'react-bootstrap-table2-paginator';
// const stack2 = (
//     <span
//       className="action"
      
//     >
//         <button>View</button>
//         <button>Edit</button>
//         <button>Delete</button>
     
//     </span>
//   );
const products = [
    { id: 1, FirstName: "Vikram", LastName: "Singh", PhoneNumber: 2020202020, Email: "abc@gmail.com" },
    { id: 2, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2220202022, Email: "abc@gmail.com" },
    { id: 3, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2320202023, Email: "abc@gmail.com" },
    { id: 4, FirstName: "Vikram", LastName: "Singh", PhoneNumber: 2020202020, Email: "abc@gmail.com" },
    { id: 5, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2220202022, Email: "abc@gmail.com" },
    { id: 6, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2320202023, Email: "abc@gmail.com" },
    { id: 7, FirstName: "Vikram", LastName: "Singh", PhoneNumber: 2020202020, Email: "abc@gmail.com" },
    { id: 8, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2220202022, Email: "abc@gmail.com" },
    { id: 9, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2320202023, Email: "abc@gmail.com" },
    { id: 10, FirstName: "Vikram", LastName: "Singh", PhoneNumber: 2020202020, Email: "abc@gmail.com" },
    { id: 11, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2220202022, Email: "abc@gmail.com" },
    { id: 12, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2320202023, Email: "abc@gmail.com" },
    { id: 13, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2320202023, Email: "abc@gmail.com" },
    { id: 14, FirstName: "Vikram", LastName: "Singh", PhoneNumber: 2020202020, Email: "abc@gmail.com" },
    { id: 15, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2220202022, Email: "abc@gmail.com" },
    { id: 16, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2320202023, Email: "abc@gmail.com" },
    { id: 17, FirstName: "Vikram", LastName: "Singh", PhoneNumber: 2020202020, Email: "abc@gmail.com" },
    { id: 18, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2220202022, Email: "abc@gmail.com" },
    { id: 19, FirstName: "Vikram", LastName: "Seth", PhoneNumber: 2320202023, Email: "abc@gmail.com" },
];
const columns = [{
    dataField: 'id',
    text: ''
},
{
    dataField: 'FirstName',
    text: 'First Name'
}, {
    dataField: 'LastName',
    text: 'Last Name'
}, 
 {
    dataField: 'Email',
    text: 'Email'
},{
    dataField: 'PhoneNumber',
    text: 'Phone Number'
},
// {
//     dataField: 'Action',
//     text: ''
// },


];

const customTotal = (from, to, size) => (
    <div className='total-number'>
    <span className="react-bootstrap-table-pagination-total">
      { from } - { to } of { size } Items
    </span>
    </div>
  );
  
const options = {
    paginationSize: 4,
    pPhoneNumberStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last pPhoneNumber button
    // hideSizePerPPhoneNumber: true, // Hide the sizePerPPhoneNumber dropdown always
    // hidePPhoneNumberListOnlyOnePPhoneNumber: true, // Hide the pagination list when only one pPhoneNumber
    firstPPhoneNumberText: 'First',
    prePPhoneNumberText: 'Back',
    nextPPhoneNumberText: <AiOutlineRight/>,
    lastPPhoneNumberText: <AiOutlineLeft/>,
    nextPPhoneNumberTitle: 'First pPhoneNumber',
    prePPhoneNumberTitle: 'Pre pPhoneNumber',
    firstPPhoneNumberTitle: 'Next pPhoneNumber',
    lastPPhoneNumberTitle: 'Last pPhoneNumber',
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePPhoneNumberTitle: true,
    sizePerPPhoneNumberList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: 'All', value: products.length
    }] // A numeric array is also available. the purpose of above example is custom the text
  };
  function UserList() {
    const [isOpen, setOpen] = useState(false);
    // const [isClose, setClose] = useState(false);
    const toggleOpen = () => {
        setOpen(!isOpen);
    };

    return (
        <>



            <div className="dashboard">
                <div className={isOpen ? 'd-flex toggled' : 'd-flex'} id="wrapper">
                    <Sidebar />
                    <div className="page-content">
                        <nav className="navbar navbar-expand-lg navbar-light bg-transparent">
                            <div className="d-flex align-items-center py-3 ps-3  d-lg-none">

                                <Link onClick={toggleOpen} role="button"><i className="fas fa-align-left primary-text fs-4 me-3" id="menu-toggle"></i></Link>

                            </div>
                            <AdminHeader />
                        </nav>
                        {/* <!-- Areas --> */}
                        <div className="dashboard-page p-4">
                            {/* contact form starts*/}
                            <div className="contact dashboard-form">
                                <div className="container">
                                <div className="contact-sub-head mb-3">
                            <h4><FiUsers/> User List</h4>
                        </div>
                                <BootstrapTable keyField='id' data={products} columns={columns} pagination={ paginationFactory(options)}/>
</div>

                            </div>
                        </div>

                        {/* contact form ends */}
                    </div>
                </div>
            </div>
        {/* </div>
</div> */}
  </>
    );
}

export default UserList